import React, { Dispatch, SetStateAction } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import TableSkeletonLoader from '../../../../ui/TableSkeletonLoader';
import {
  ContextBasedGeneratorJob,
  QuestionGeneratorJob,
  TopicBasedGeneratorJob,
} from '../../../../utils/types/content_manager_types';
import { Document } from './document/document';
import { TriageRow } from './triage_row/triage_row';

interface DocumentTriageProps {
  documents: (ContextBasedGeneratorJob | TopicBasedGeneratorJob)[];
  setDocuments: Dispatch<
    SetStateAction<(ContextBasedGeneratorJob | TopicBasedGeneratorJob)[]>
  >;
  loading: boolean;
}

export const DocumentTriage = ({
  documents,
  setDocuments,
  loading,
}: DocumentTriageProps) => {
  const updateJob = (newJobData: QuestionGeneratorJob) => {
    const updatedDocuments = documents.map((doc) =>
      doc.id === newJobData.id ? newJobData : doc,
    );
    setDocuments(updatedDocuments);
  };

  return (
    <Paper
      variant='outlined'
      sx={{
        borderRadius: 2,
        overflow: 'hidden',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          overflowX: 'auto',
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'grey.50',
          scrollbarWidth: 'thin',
        }}
      >
        <TriageRow>
          <Typography variant='caption' fontWeight={600} color='text.secondary'>
            Document Title
          </Typography>
          <Typography variant='caption' fontWeight={600} color='text.secondary'>
            Upload Date
          </Typography>
          <Typography variant='caption' fontWeight={600} color='text.secondary'>
            Status
          </Typography>
          <Typography variant='caption' fontWeight={600} color='text.secondary'>
            Uploaded By
          </Typography>
        </TriageRow>
      </Box>

      {loading ? (
        <TableSkeletonLoader />
      ) : (
        <Box
          sx={{
            overflowX: 'auto',
            scrollbarWidth: 'thin',
          }}
        >
          {documents.map((documentProps) => (
            <Document
              key={documentProps.id}
              job={documentProps}
              updateJob={updateJob}
            />
          ))}
        </Box>
      )}
    </Paper>
  );
};
